import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const MessagingInterface = ({ conversations }) => {
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [message, setMessage] = useState('');

  const formatTime = (date) => {
    return new Intl.DateTimeFormat('tr-TR', {
      hour: '2-digit',
      minute: '2-digit'
    })?.format(new Date(date));
  };

  const handleSendMessage = (e) => {
    e?.preventDefault();
    if (message?.trim()) {
      console.log('Mesaj gönderildi:', message);
      setMessage('');
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden h-[600px] flex">
      <div className="w-full md:w-80 border-r border-border flex flex-col">
        <div className="p-4 border-b border-border">
          <h2 className="text-lg font-semibold text-foreground mb-3">Mesajlar</h2>
          <div className="relative">
            <Icon name="Search" size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              placeholder="Ara..."
              className="w-full pl-10 pr-4 py-2 bg-muted border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto">
          {conversations?.map((conversation) => (
            <button
              key={conversation?.id}
              onClick={() => setSelectedConversation(conversation)}
              className={`
                w-full p-4 flex items-start gap-3 hover:bg-muted transition-smooth border-b border-border
                ${selectedConversation?.id === conversation?.id ? 'bg-muted' : ''}
              `}
            >
              <div className="relative flex-shrink-0">
                <div className="w-12 h-12 rounded-full overflow-hidden">
                  <Image 
                    src={conversation?.avatar} 
                    alt={conversation?.avatarAlt}
                    className="w-full h-full object-cover"
                  />
                </div>
                {conversation?.unread > 0 && (
                  <div className="absolute -top-1 -right-1 w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                    <span className="text-xs font-bold text-primary-foreground">{conversation?.unread}</span>
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0 text-left">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-semibold text-foreground truncate">{conversation?.name}</h3>
                  <span className="text-xs text-muted-foreground">{formatTime(conversation?.lastMessageTime)}</span>
                </div>
                <p className="text-sm text-muted-foreground truncate">{conversation?.lastMessage}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
      <div className="hidden md:flex flex-1 flex-col">
        {selectedConversation ? (
          <>
            <div className="p-4 border-b border-border flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden">
                  <Image 
                    src={selectedConversation?.avatar} 
                    alt={selectedConversation?.avatarAlt}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground">{selectedConversation?.name}</h3>
                  <p className="text-xs text-muted-foreground">Çevrimiçi</p>
                </div>
              </div>
              <button className="p-2 hover:bg-muted rounded-md transition-smooth">
                <Icon name="MoreVertical" size={20} />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-4 space-y-4">
              {selectedConversation?.messages?.map((msg, index) => (
                <div key={index} className={`flex ${msg?.sender === 'me' ? 'justify-end' : 'justify-start'}`}>
                  <div className={`
                    max-w-[70%] rounded-lg p-3
                    ${msg?.sender === 'me' ? 'bg-primary text-primary-foreground' : 'bg-muted text-foreground'}
                  `}>
                    <p className="text-sm">{msg?.text}</p>
                    <span className={`text-xs mt-1 block ${msg?.sender === 'me' ? 'text-primary-foreground/70' : 'text-muted-foreground'}`}>
                      {formatTime(msg?.time)}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <form onSubmit={handleSendMessage} className="p-4 border-t border-border">
              <div className="flex items-center gap-2">
                <button type="button" className="p-2 hover:bg-muted rounded-md transition-smooth">
                  <Icon name="Paperclip" size={20} />
                </button>
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e?.target?.value)}
                  placeholder="Mesajınızı yazın..."
                  className="flex-1 px-4 py-2 bg-muted border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
                />
                <Button type="submit" iconName="Send" disabled={!message?.trim()}>
                  Gönder
                </Button>
              </div>
            </form>
          </>
        ) : (
          <div className="flex-1 flex items-center justify-center text-center p-8">
            <div>
              <Icon name="MessageSquare" size={48} className="mx-auto mb-4 text-muted-foreground opacity-50" />
              <p className="text-muted-foreground">Bir sohbet seçin</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessagingInterface;